// extracted by mini-css-extract-plugin
export var caption = "newsletter-story-module--caption--4dc6e";
export var content = "newsletter-story-module--content--a48c0";
export var intro = "newsletter-story-module--intro--199e9";
export var regionalImage = "newsletter-story-module--regionalImage--f88ec";
export var sectionPartner = "newsletter-story-module--sectionPartner--ac5f8";
export var social = "newsletter-story-module--social--b1414";
export var spin = "newsletter-story-module--spin--d0cde";
export var subject = "newsletter-story-module--subject--5faa7";
export var title = "newsletter-story-module--title--dc2de";
export var wrapper = "newsletter-story-module--wrapper--61c41";